<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            Código de barras
          </th>
          <th class="text-left">
            Vencimento
          </th>
          <th class="text-left">
            Valor boleto
          </th>
          <th class="text-left">
            Data pagamento
          </th>
          <th class="text-left">
            Valor pagamento
          </th>
          <th class="text-left">
            Data cadastro
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="boleto in boletos" :key="boleto.id">
          <td>{{ boleto.codigo_de_barras }}</td>
          <td>{{ boleto.data_vencimento | data }}</td>
          <td>{{ boleto.valor_boleto | dinheiro }}</td>
          <td>{{ boleto.data_pagamento | data }}</td>
          <td>{{ boleto.valor_pagamento | dinheiro }}</td>
          <td>{{ boleto.created_at | data }}</td>
        </tr>
        <tr v-if="!boletos.length">
          <td colspan="6" class="text-center">Nenhum boleto foi encontrado.</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import urlApi from "@/routes/urlApi";

export default {
  name: "Boletos",

  data() {
    return {
      boletos: [],
      isLoading: true,
    };
  },

  props: {
    idAuto: {
      type: Number,
      required: true,
    },
  },

  components: {},

  filters: {},

  methods: {
    getBoletos() {
      this.$http
        .get(`${urlApi}/v2/autos/${this.idAuto}/boletos`)
        .then((response) => {
          this.boletos = response.data.boletos;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },

  mounted() {
    this.getBoletos();
  },
};
</script>
